<template>

  <div class="login" id="loginid">

    <div class="title" style=" position:absolute;text-align:center;width:100%;">

      <div class="img1" style="display:flex;float:left;width:300px;width: 22%;margin-top:5rem">
        <img class="imgstyle" style="float:left;margin-left:80px;" src="/static/images/login/QRCode.jpg">
        <img class="imgstyle" style="float:left;margin-left:40px;" src="/static/images/login/QRCode2.jpg">
      </div>

      <div class="txt1" style="display:inline-block;float:right;margin-right:80px;margin-top:5rem;height:100%;width: 20%;">

        <span class="help" style="display:block;width:100%;font-size:20px;text-align:right;">
          <!-- <a class="lanb" style="font-size:20px;" href="/static/templates/帮助手册.doc">帮助手册</a> 
          <span>|</span>-->
          <span class="lanb" style="font-size:20px;">中文</span>
          <span>|</span>
          <span class="lana" style="font-size:20px;" @click="clk()">English </span>
        </span>
        <a class="lanb" style="font-size:25px;width:100%;display:block;text-align:right;float: right;"
         href="http://www.fireexpo.cn" target="_blank">返回首页</a>
        <!--
        <span class="lanb" @click="zgclk"
        style="font-size:25px;background:rgba(0,0,0,0.4);display:block;padding:5px;margin-top:5px;margin-bottom:5px;text-align:right;width: 210px;float: right;">查看展位预定情况
        </span>
       <a class="lanb" style="font-size:25px;width:100%;display:block;text-align:right;float: right;padding:5px;margin-top:5px;margin-bottom:5px;" href="/static/templates/展馆图片.rar">下载展位图片</a>
       <a class="lanb" style="font-size:20px;width:100%;display:block;text-align:right;float: right;padding:5px;margin-top:5px;margin-bottom:5px;" href="/static/templates/装备器材馆-3或4个标位档位展商备选区域示意图.zip">装备器材馆3或4个标位档位展商备选区域示意图</a>
        -->
      
      </div>
      <div class="tit" style="display:inline-block;text-align:center;margin-top:7rem;margin-left:20px;width: 50%;">
        <span style=" display:inline-block;text-align:center;">
          <img style="display:inline-block;height:80px;width:80px; vertical-align:middle;" src="/static/images/login/logo.png">
          <span id="txta" style="color:#fff;font-weight:bold;display:inline-block; vertical-align:middle;">CHINA FIRE
            2025</span>
        </span>
        <span id="txtb" style="color:#fff;font-weight:bold;display:block;text-align:center">第二十一届中国国际消防展展商系统</span>
      </div>


    </div>


    <router-view></router-view>
    <el-row class="footerstyle" id="footer">
      <el-col :span="4">&nbsp;</el-col>
      <el-col :span="16" class="footer">
        <p>建议使用谷歌、搜狗、360和火狐浏览器</p>
        <p>业务咨询：010-87792206 87792278 87789262，技术支持：024-31535773，分机号602</p>
        <!-- <p>业务咨询：010-87792278，技术支持：024-31530337，分机号606</p> -->
      </el-col>
      <el-col :span="4">&nbsp;</el-col>
    </el-row>
  </div>
</template>

<script>
  import Login from "@/views/exhibition/login/ch/Login";
  import Register from "@/views/exhibition/login/ch/Register";
  import Reset from "@/views/exhibition/login/ch/Reset";
  import ForgetPassword from "@/views/exhibition/login/ch/ForgetPassword";
  import ForgetUsername from "@/views/exhibition/login/ch/ForgetUsername";

  export default {
    name: "login",
    components: {
      login: Login,
      register: Register,
      forgetpassword: ForgetPassword,
      forgetusername: ForgetUsername,
      reset: Reset
    },
    data() {
      return {

      };
    },
    created: function() {

    },

    mounted: function() {
      let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
      //获取htmlDom
      let htmlDom = document.getElementsByTagName('html')[0];
      //设置html的font-size
      htmlDom.style.fontSize = htmlWidth / 120 + 'px';
      window.addEventListener('resize', (e) => {
        let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
        //获取htmlDom
        let htmlDom = document.getElementsByTagName('html')[0];
        //设置html的font-size
        htmlDom.style.fontSize = htmlWidth / 120 + 'px';
      })
      this.init()
    },

    methods: {

      clk() {
        this.$router.push({
          path: '/exhibition/login/en/Login'
        });
      },
      zgclk() {
        this.$router.push({
          path: '/plan/planAnon'
        });
      },
      //适配屏幕分辨率
      init() {
        //判断是否宽屏
        var winWide = window.screen.availWidth;

        if (winWide < 1400) {
          document.getElementById("txta").style.fontSize = "40px";
          document.getElementById("txtb").style.fontSize = "40px";
        } else {
          document.getElementById("txta").style.fontSize = "50px";
          document.getElementById("txtb").style.fontSize = "50px";
        }
      },

    }

  };
</script>

<style lang="scss" scoped>
  @import '@/common/scss/login.scss';



  // 右侧中英文切换样式
  .market_out {
    width: 500px;

    .el-tabs__item {
      color: red;
    }
  }

  .lana {
    color: $blackcolor;
  }

  .lanb {
    color: $whitecolor;
  }

  .footer {

    margin-top: 1.5rem;

    p {
      margin: 0px;
      padding: 0px;
      height: 1.8rem;
    }

    text-align: center;
    color: $whitecolor;
    font-size: 0.7rem;

    * {
      text-align: center;
      color: $whitecolor;
      font-size: 0.7rem;
    }
  }

  .footerstyle p {
    font-size: 1.25rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/common/Login.vue